export const getHardCodedElement = (
  permission_id: string
): JSX.Element | null => {
  const getValueBasedOnPermissions = (): string[] | null => {
    switch (permission_id) {
      case "1000": // Aktiv spelrätt
        return null;

      case "1600": // Elitnål
        return null;

      case "1200": // Företag
        return null;

      case "1700": // Företag b
        return null;

      case "7000": // Junior (Redigera inte)
        return [
          "Kan bara boka en tid åt gången och bara på bana 11 om det är en tränare som är tillgänglig.",
          "Kan inte boka tider mellan 16 - 19 på veckodagar",
        ];

      case "7700": // Junior b (Redigera inte)
        return [
          "Kan bara boka en tid åt gången och bara på bana 11 om det är en tränare som är tillgänglig.",
          "Kan inte boka tider mellan 16 - 19 på veckodagar",
        ];

      case "2500": // Junior spelrätt
        return [
          "Boka alla tider och banor inomhus maj, juni, juli och augusti = tillika ej betala gästavgift på dessa tider och kunna boka privatlektioner.",
          "Boka alla tider och banor utomhus i juli och september = tillika ej betala gästavgift (medspelaravgifter) på dessa tider och kunna boka privatlektioner.",
          "Får bara ha 3 bokingar under en vecka",
          "Får bara ha en bokning åt gången",
          "Ska betala 50% på gästavgiften första 3 gångerna som medspelare på tider de ej får boka - därefter full gästavgift",
        ];

      case "2000": // Kltk kansli
        return null;

      case "1900": // Kö
        return null;

      case "1010": // Non residential
        return [
          "1 maj - 31 augusti spela gratis som gäst (medspelare) samt boka bana 5 minuter innan via receptionen.",
          "15 december - 15 januari spela gratis som gäst samt boka bana 5 minuter innan via receptionen.",
        ];
      case "1300": // Personal
        return null;

      case "1950": // Prioriterad gäst
        return [
          "1 maj - 15 september boka alla tider och banor inomhus (ingen bokningsrätt utomhus annat än på ledig bana vid spelstart).",
          "Bokningsrätten fungerar under denna period precis på samma sätt som när KLTK:s medlemmar som innehar Aktiv spelrätt bokar banor inomhus. Dvs. en timme i taget och en sista minuten bokning kl. 17.00 dagen innan.",
          "Prioriterad gäst får inte boka privatlektioner eller aktiviteter under denna period.",
          "Ska ej betala gästavgift under denna period. De betalar dock gästavgift utanför denna period som grund och får vara med som medspelare på en privatlektion mot betalning av gästavgift (som grundinställning).",
        ];
      case "1050": // Senior spelrätt
        return null;

      case "1500": // Temporär spelrätt
        return [
          "Boka alla tider och banor inomhus maj, juni, juli och augusti = tillika ej betala gästavgift på dessa tider och kunna boka privatlektioner.",
          "Boka alla tider och banor utomhus i juli och september = tillika ej betala gästavgift på dessa tider och kunna boka privatlektioner.",
        ];
      case "8100": // Utan rättigheter
        return null;

      case "4000": // Vilande spelrätt
        return null;

      case "5000": // Vilande spelrätt..
        return null;

      default:
        return null; // Return nothing if unknown
    }
  };

  const value = getValueBasedOnPermissions();
  if (value === null) return null;

  return (
    <div className="general-popup-form-group">
      <div className="general-popup-form-field">
        <label htmlFor="memberType" className="text-s">
          Hårdkodat:
        </label>

        <div className="hardcoded-value-list">
          {value.map((item, index) => (
            <div key={index} className="text-m">
              - {item}
            </div>
          ))}
        </div>

        {/* <div className="hardcoded-value">{value}</div> */}
      </div>
    </div>
  );
};
